import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuoteLeft, faQuoteRight } from "@fortawesome/free-solid-svg-icons";

const Wrapper = styled.div`
  font-family: ${({ theme }) => theme.fontParagraphs.fontFamily};
  width: 100%;
  display: flex;
  flex-direction: column;
  p {
    margin-block: 0.5rem 0;
  }
`;
const LeftQuotationMark = styled(FontAwesomeIcon)`
  padding-right: 1rem;
`;
const RightQuotationMark = styled(FontAwesomeIcon)`
  padding-left: 1rem;
`;
const Quote = styled.p`
  font-size: 1.2rem;
`;
const Author = styled.p`
  @media (max-width: ${({ theme }) => theme.breakpoints.phone}) {
    text-align: end;
  }
`;

export default function SingleQuote({ author, className, quote }) {
  return (
    <Wrapper className={className}>
      <Quote>
        <LeftQuotationMark icon={faQuoteLeft} />
        {quote}
        <RightQuotationMark icon={faQuoteRight} />
      </Quote>
      <Author>- {author}</Author>
    </Wrapper>
  );
}

SingleQuote.propTypes = {
  author: PropTypes.string,
  className: PropTypes.string,
  backgroundColor: PropTypes.string,
  quote: PropTypes.string,
};
